var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.networkErrorImg,
      "alt": "network error"
    }
  }), _c('div', [_c('k18n', [_vm._v("Low network")])], 1), _c('Button', {
    staticClass: "button",
    on: {
      "click": function click($event) {
        return _vm.$emit('click-btn');
      }
    }
  }, [_c('k18n', [_vm._v("Refresh")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }